import { render, staticRenderFns } from "./asesor_capacitacion.vue?vue&type=template&id=b52347c8"
import script from "./asesor_capacitacion.vue?vue&type=script&lang=js"
export * from "./asesor_capacitacion.vue?vue&type=script&lang=js"
import style0 from "./asesor_capacitacion.vue?vue&type=style&index=0&id=b52347c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports